import { HeaderConfigBlockState } from './types';

const defaultState: HeaderConfigBlockState = {
    settings: {
        fontSize: 100,
        fontColor: '#DDDDDD',
        fontWeight: 'bold',
        backgroundColor: '#16161d',
        heading: 'Default heading',
        showCardinalDirections: false,
        showReportTime: true,
    },
    databilities: [],
};

export default defaultState;
